import AddIcon from "@mui/icons-material/Add";
import { Button, FlexColumn, Placeholder } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import rootStore from "csi/state/rootStore";
import imageSrc from "Images/TablePlaceholderNoResult.png";
import React from "react";


export const EmptyEnvironments = () => {
	const loc = useLocale();
	const { threeDStore: { environmentsStore, has3DLibraryAdminRole } } = rootStore;
	const { onNew3DEnvironment } = environmentsStore;

	return (
		<FlexColumn
			alignItems='center'
			justifyContent='center'
		>
			<Placeholder
				subtitleMargin={6}
				subtitleProps={{ res: "3DAddHDRI" }}
				titleProps={{ res: "SEARCH_NO_RESULTS" }}
			>
				{{
					actions:
                        has3DLibraryAdminRole && (
                        	<Button
                        		design="secondary"
                        		onClick={onNew3DEnvironment}
                        		res="New_Name"
                        		resParams={[loc.type("ThreeDEnvironment")]}
                        		startIcon={<AddIcon />}
                        	/>
                        )
					,
					image:
                        <img height={72} src={imageSrc} />
					,
				}}
			</Placeholder>
		</FlexColumn>
	);
};